/**
 * Compares two spellings of a search the way search-party does: trimmed, single-spaced and lowercase.
 */
export const normalizeSearchTerm = (searchTerm: string): string => searchTerm.trim().replace(/\s+/g, ' ').toLowerCase();
